
export default {
  name: 'TagCard',
  props: {
    tag: {
      type: Object,
      default: () => ({}),
    },
  }
}
